<div class="form-container">
    <h2>Creación de Acta de Inicio</h2>

    <!-- Contratista -->
    <div *ngIf="currentStep === 1" class="step">
        <form>
            <div class="section">
                <h3 class="section-title">Contratista</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractorName">Nombre del Contratante</label>
                        <input id="contractorName" type="text" [(ngModel)]="contractor.name"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre Completo" />
                    </div>
                    <div class="form-group">
                        <label for="contractorTypeId">Tipo de Identificacion</label>
                        <select id="contractorTypeId" [(ngModel)]="contractor.idType"
                            [ngModelOptions]="{standalone: true}">
                            <option value="CC">Cédula de ciudadanía</option>
                            <option value="CE">Cédula de extranjería</option>
                            <option value="PA">Pasaporte</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="contractorId">Número de Identificación</label>
                        <input id="contractorId" type="number" [(ngModel)]="contractor.id"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" />
                    </div>
                </div>
            </div>
            <div class="section">
                <h3 class="section-title">Contrato</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractNumber">Número de Contrato</label>
                        <input id="contractNumber" type="number" [(ngModel)]="contract.contractNumber"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" />
                    </div>
                    <div class="form-group">
                        <label for="contractDuration">Duración del Contrato</label>
                        <input id="contractDuration" type="text" [(ngModel)]="contract.contractDuration"
                            [ngModelOptions]="{standalone: true}" placeholder="1 Año" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractObject">Descripción de Objeto</label>
                        <textarea id="contractObject" rows="4" [(ngModel)]="contract.contractObject"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Describe el objeto del contrato"></textarea>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractDateIni">Fecha de Inicio</label>
                        <input id="contractDateIni" type="date" [(ngModel)]="contract.contractDateIni"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="form-group">
                        <label for="contractDateEnd">Fecha de Fin</label>
                        <input id="contractDateEnd" type="date" [(ngModel)]="contract.contractDateEnd"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="form-group">
                        <label for="contractValue">Valor Total del Contrato</label>
                        <input id="contractValue" type="number" [(ngModel)]="contract.contractValue"
                            [ngModelOptions]="{standalone: true}" placeholder="0000000" />
                    </div>
                    <div class="form-group">
                        <label for="contractValueWords">Valor en Letras</label>
                        <input id="contractValueWords" type="text" [(ngModel)]="contract.contractValueWords"
                            [ngModelOptions]="{standalone: true}" placeholder="Un millon de pesos" />
                    </div>
                </div>
            </div>

            <!-- Botón siguiente -->
            <div class="form-actions">
                <button type="button" class="next" (click)="saveAsDraft()">Guardar Formulario</button>
                <button type="button" class="next" (click)="goToNextStep()">Siguiente</button>
            </div>
        </form>
    </div>

    <!-- Supervicion -->
    <div *ngIf="currentStep === 2" class="step">
        <form>
            <div class="section">
                <h3 class="section-title">Supervicion</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="supervisorName">Nombre del Supervisor</label>
                        <input id="supervisorName" type="text" [(ngModel)]="supervisor.supervisorName"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre Completo" />
                    </div>
                    <div class="form-group">
                        <label for="supervisorTypeId">Tipo de Identificacion</label>
                        <select id="supervisorTypeId" [(ngModel)]="supervisor.supervisorTypeId"
                            [ngModelOptions]="{standalone: true}">
                            <option value="CC">Cédula de ciudadanía</option>
                            <option value="CE">Cédula de extranjería</option>
                            <option value="PA">Pasaporte</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="supervisorId">Número de Identificación</label>
                        <input id="supervisorId" type="number" [(ngModel)]="supervisor.supervisorId"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" />
                    </div>
                </div>
            </div>
            <div class="section">
                <h3 class="section-title">Lugar y Observaciones</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="placePerformance">Lugar de Ejecusion</label>
                        <input id="placePerformance" type="text" [(ngModel)]="place.placePerformance"
                            [ngModelOptions]="{standalone: true}" placeholder="Boyaca" />
                    </div>
                    <div class="form-group">
                        <label for="placeSignature">Lugar de Firma</label>
                        <input id="placeSignature" type="text" [(ngModel)]="place.placeSignature"
                            [ngModelOptions]="{standalone: true}" placeholder="Boyaca" />
                    </div>
                    <div class="form-group">
                        <label for="placeDate">Fecha de Firma</label>
                        <input id="placeDate" type="date" [(ngModel)]="place.placeDate"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
                <div class="form-group">
                    <label for="placeObservation">Observaciones</label>
                    <textarea id="placeObservation" rows="4" [(ngModel)]="place.placeObservation"
                        [ngModelOptions]="{standalone: true}" placeholder="Observaciones adicionales"></textarea>
                </div>
            </div>

            <!-- Botón siguiente -->
            <div class="form-actions">
                <button type="button" class="previous" (click)="goToPreviousStep()">Anterior</button>
                <button type="button" class="next" (click)="saveAsDraft()">Guardar Formulario</button>
                <button type="button" class="next" (click)="generateDocument()">Generar Acta</button>
            </div>
        </form>
    </div>
</div>